import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AirspaceRiskSidebarComponent } from './view/airspace-risk-sidebar/airspace-risk-sidebar.component';
import { AirspaceRiskViewComponent } from './view/airspace-risk-view/airspace-risk-view.component';

@NgModule({
    imports: [CommonModule, RouterModule.forChild([])],
    declarations: [AirspaceRiskViewComponent, AirspaceRiskSidebarComponent]
})
export class AirspaceRiskModule {}
